var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmapMap',_vm._b({ref:"myMap",class:_vm.classes,attrs:{"options":_vm.myOptions}},'gmapMap',Object.assign({}, _vm.$attrs, _vm.$props),false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }